import React, { useEffect, useState } from "react";
import axiosInstance from "../axios/login";
// import { useHistory } from "react-router-dom";
import ReactFacebookLogin from "react-facebook-login";
import ReactGoogleLogin from "react-google-login";
import { useSelector, useDispatch } from "react-redux";
import { facebookLogin, googleLogin } from "../axios/SocialLogin";
import { Formik, Form, Field } from "formik";
import { logInUser, setUserPermissions } from "../redux/slices/user/userSlice";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import "animate.css";
import { BiHide, BiShow } from "react-icons/bi";
import axios from "axios";
import { getAuthorization } from "../axios/AxiosAut";

const validationSchema = Yup.object({
  username: Yup.string().email("Invalid Email").required("Email Required"),
  password: Yup.string().required("Password is required"),
});

export default function SignIn() {
  const dispatch = useDispatch();
  const [Show, setShow] = useState(false);
  let navigate = useNavigate();
  const search = useLocation().search;
  const comp = new URLSearchParams(search).get("comp");
  const token = new URLSearchParams(search).get("token");
  const Expire = new URLSearchParams(search).get("token_valid");

  useEffect(() => {
    if (token !== null && Expire == "True") {
      axios
        .post("https://web-production-3590.up.railway.app/company/add_staff/", {
          comp: comp,
          token: token,
        })
        .then((res) => {
          console.log("Message", res);
          Swal.fire({
            position: "top-end",
            title: "Welcome!",
            showConfirmButton: false,
            timer: 5500,
            showClass: {
              popup: "animate__animated animate__fadeInRight",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutRight",
            },
            width: 300,
            color: "#FFFFFF",
            background: "#2A91D7",
            backdrop: `rgba(0,0,0,0)`,
          });
        })
        .catch((err) => {
          console.log("Error", err);
        });
    } else if (Expire == "False") {
      Swal.fire({
        position: "top-end",
        title: "Invitation Expired!",
        showConfirmButton: false,
        timer: 5500,
        showClass: {
          popup: "animate__animated animate__fadeInRight",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutRight",
        },
        width: 300,
        color: "#FFFFFF",
        background: "#2A91D7",
        backdrop: `rgba(0,0,0,0)`,
      });
    }
  }, []);

  const setPermissions = () => {
    getAuthorization()
      .get("/users/user_permissions/")
      .then((res) => {
        dispatch(setUserPermissions(res.data));
      })
      .catch((err) => {
        console.log("Error in getting user Permissions", err);
      });
  }; 

  const initialValues = {
    username: "admin@facto.com",
    password: "Testuser123",
  };
  const onSubmit = (values, onSubmitProps) => {
    console.log("Form Data", values);
    dispatch(
      logInUser({
        ...values,
        navigate: navigate,
        onSubmitProps: onSubmitProps,
        setPermissions: setPermissions,
      })
    );
  };
  const Navigate = useNavigate();
  function responseGoogle(response) {
    console.log("google", response);
    googleLogin(response.accessToken, Navigate);
  }
  //const key = process.env.REACT_APP_google_client_id;


  return (
    <>
      <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <h2 className="mt-28 text-left font-Montserrat text-2xl font-bold text-black">
              Login to your account
            </h2>
            <div className="border-b-2 border-blue-200 w-24"></div>
          </div>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            validateOnMount
          >
            <Form className="mt-10 space-y-10">
              <Field name="username">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <input
                        {...field}
                        type="text"
                        {...(meta.touched && meta.error
                          ? {
                              className:
                                "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                            }
                          : {
                              className:
                                "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                            })}
                        placeholder="Email"
                      ></input>
                      {meta.touched && meta.error ? (
                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                          <span className="ml-1">{meta.error}</span>
                        </label>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field name="password">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <div className="relative text-gray-600 focus-within:text-gray-400">
                        <span className="absolute inset-y-0 left-96 flex items-center pl-2">
                          <button
                            type="button"
                            onClick={() => setShow(!Show)}
                            className="p-5 focus:outline-none focus:shadow-outline"
                          >
                            {!Show ? (
                              <BiHide size={25} />
                            ) : (
                              <BiShow size={25} />
                            )}
                          </button>
                        </span>
                        <input
                          {...field}
                          type={!Show ? "password" : "text"}
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Password"
                          con
                        ></input>
                      </div>
                      {meta.touched && meta.error ? (
                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                          <span className="ml-1">{meta.error}</span>
                        </label>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field>
                {(props) => {
                  const { field, form, meta } = props;
                  const { isSubmitting } = form;
                  return (
                    <>
                      {!isSubmitting ? (
                        <button
                          type="submit"
                          {...(form.isValid
                            ? {
                                className:
                                  "font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow ",
                              }
                            : {
                                disabled: true,
                                className:
                                  "font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow opacity-50 cursor-not-allowed",
                              })}
                        >
                          Log In
                        </button>
                      ) : (
                        <button
                          disabled
                          className="font-Montserrat font-semibold flex-shrink bg-blue-200 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow"
                        >
                          <div className="flex items-center justify-center space-x-2 animate-pulse">
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                          </div>
                        </button>
                      )}
                    </>
                  );
                }}
              </Field>
              <div>
                <p className="-my-6 text-left text-xs font-Montserrat font-semibold text-black">
                  Don't have an account?{" "}
                  <Link
                    className="font-Montserrat text-blue-200 font-semibold"
                    to="/register"
                  >
                    Create One
                  </Link>
                </p>
                <p className="pt-1 text-right">
                  <Link
                    className="font-Montserrat text-blue-200 text-xs font-semibold"
                    to="/forget-password"
                  >
                    Forgot Password?
                  </Link>
                </p>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </>
  );
}
